import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import App from './App';
import RankedElectionsList from './RankedElectionsList';
import RankedElectionVotesList from './RankedElectionVotesList';
import RankedElectionDetail from './RankedElectionDetail';
import RankedElectionCreate from './RankedElectionCreate';
import RankedElectionCreateVote from './RankedElectionCreateVote';
import RankedElectionUpdateVote from './RankedElectionUpdateVote';
import RankedElectionResult from './RankedElectionResult';
import RankedElectionVoteDetail from './RankedElectionVoteDetail';
import PrivacyInfo from './PrivacyInfo';

function Root() {
    return (
        <Router>
            <Routes>
                <Route exact path="/" element={<App />}/>
                <Route path="/privacy" element={<PrivacyInfo/>}/>
                <Route path="/create-election" element={<RankedElectionCreate/>}/>
                <Route path="/ranked-elections" element={<RankedElectionsList/>}/>
                <Route path="/ranked-elections/:id" element={<RankedElectionDetail/>}/>
                <Route path="/ranked-elections/:id/create-vote" element={<RankedElectionCreateVote/>}/>
                <Route path="/ranked-elections/:id/result" element={<RankedElectionResult/>}/>
                <Route path="/ranked-elections/:id/votes" element={<RankedElectionVotesList/>}/>
                <Route path="/ranked-elections/:electionId/votes/:voteId" element={<RankedElectionVoteDetail/>}/>
                <Route path="/ranked-elections/:electionId/votes/:voteId/update-vote" element={<RankedElectionUpdateVote/>}/>
            </Routes>
        </Router>
);
}

export default Root;